import React from 'react';

import { EmptyState } from '@components/EmptyState';
import { Text, textVariantsEnum, fontWeightEnum } from '@components/Text';

import styles from './PlaceholderSection.module.scss';

export const PlaceholderSection = ({ navItem, title }) => (
  <div className={styles.placeholder}>
    <EmptyState
      customMessageComponent={
        <div className={styles.messageStack}>
          <Text
            variant={textVariantsEnum.Text_md}
            fontWeight={fontWeightEnum.Semibold}
            color="gray-700"
          >
            {navItem?.title || title} settings coming soon
          </Text>
          <Text
            variant={textVariantsEnum.Text_sm}
            fontWeight={fontWeightEnum.Normal}
            color="gray-500"
          >
            This section is being designed and will be available shortly.
          </Text>
        </div>
      }
    />
  </div>
);

PlaceholderSection.displayName = 'PlaceholderSection';
